import { Modal } from '@fluentui/react';
import { FC } from 'react';
import { ModalHeader } from '../../shared/styled-components';
import TheUltimateBarChart, { ITheUltimateBarChartProps } from './TheUltimateBarChart';

interface IProps {
  isOpen: boolean;
  onDismiss(): void;
  title: string;
  chartProps: ITheUltimateBarChartProps;
}

const ChartDisplayModal: FC<IProps> = ({ isOpen, onDismiss, title, chartProps }) => (
  <Modal
    isOpen={isOpen}
    onDismiss={onDismiss}
    isBlocking={false}
    styles={{ main: { width: 450 } }}
  >
    <ModalHeader title={title} onCancel={onDismiss} />
    <TheUltimateBarChart {...chartProps} />
  </Modal>
);

export default ChartDisplayModal;